/**
 * This is the core module exporting Api modules.
 *
 *
 *
 * See [[Application]] and [[Map]] for main classes and export.
 * 
 *
 * @module geo
 * @preferred
 */

/** 
 * @preferred
 */

import 'babel-polyfill';

import {application, Application, createApplication, createApplicationAsync} from './application';

export * from './actions/creators/index';

export {Application, createApplication, application, createApplicationAsync};
